import { Routes } from '@angular/router';
import { notSsoAuthGuard } from './core/guards/not-sso-auth-guard/not-sso-auth.guard';
import { ssoAuthGuard } from './core/guards/sso-auth-guard/sso-auth.guard';
import { SsoCallbackComponent } from './modules/auth/pages/sso-callback/sso-callback.component';

export const routes: Routes = [
  {
    path: '',
    component: SsoCallbackComponent,
    canActivate: [notSsoAuthGuard],
  },
  {
    path: 'home',
    loadChildren: () =>
      import('./modules/home/home.routes').then(r => r.routes),
    canActivate: [ssoAuthGuard],
  },
  {
    path: 'admin',
    loadChildren: () =>
      import('./modules/admin/admin.routes').then(r => r.routes),
    canActivate: [ssoAuthGuard],
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full',
  },
];
